// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget_G5E1c {
  display: inline-block;
}

.editing_aw6_Y {
  vertical-align: middle;
}

.pane_vROCx {
  display : flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
}

.node-widgetNode.ProseMirror-selectednode .widget_G5E1c {
  background-color: Highlight;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/detail/customText/textEditor/extensions/WidgetNode.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".widget {\n  display: inline-block;\n}\n\n.editing {\n  vertical-align: middle;\n}\n\n.pane {\n  display : flex;\n  align-items: center;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n:global(.node-widgetNode.ProseMirror-selectednode) .widget {\n  background-color: Highlight;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"widget": `widget_G5E1c`,
	"editing": `editing_aw6_Y`,
	"pane": `pane_vROCx`
};
export default ___CSS_LOADER_EXPORT___;
